import { Theme, styled } from "@material-ui/core"
import { IconArrow } from '../icons/';
import { useState } from "react"

export type TreeProps = {
    id?: string
    className?: string
    nodes: TreeNode[]
}

export type TreeNode = {
    name?: string,
    status?: string,
    description?: string,
    customRenderer?: () => React.ReactNode
    nodes: TreeNode[]
}

const Node = ({ node, isRoot, className }: { node: TreeNode, isRoot?: boolean, className?: string }) => {

    const [ isOpen, setIsOpen ] = useState(true)
    const hasChildren = !!node.nodes.length

    return (
        <div style={{paddingLeft: isRoot ? "" : "1rem"}}>
            <NodeWrapper>
                <StyledNode className={className}>
                    <div onClick={() => { setIsOpen(!isOpen) }} 
                        style={{ 
                            cursor: hasChildren ? "pointer" : "inherit", 
                            paddingRight: ".5rem", 
                            userSelect: "none" }}>
                        <div style={{ 
                            transform: isOpen && hasChildren ? "" : "rotate(-90deg)",
                            opacity: hasChildren ? 1 : 0,
                            display: "inline-block",
                            width: ".8rem",
                        }}>
                            <IconArrow />
                        </div>
                    </div>
                    <div>
                        <Name>{node.name}</Name>
                        <div><i>{node.status}</i></div>
                        <div>{node.description}</div>
                        {node.customRenderer && node.customRenderer()}
                    </div>
                </StyledNode>
            </NodeWrapper>
            <Nodes open={isOpen}>
                {node.nodes.map((node: TreeNode, index: number) => 
                    <Node className={className} node={node} key={index} />)}
            </Nodes>
        </div>)
}

export const Tree = ({ id, className, nodes }: TreeProps) => {
    return (
        <div id={id}>
            {nodes.map((node, index) => 
                <Node className={className} node={node} key={index} isRoot={true} />)}
        </div>)
}

const Nodes = styled('div')<Theme, {open: boolean}>(({ theme, open }) => ({
    display: open ? "" : "none"
}));

const NodeWrapper = styled('div')(({ theme }) => ({
    display: "flex",
}));

const StyledNode = styled('div')(({ theme }) => ({
    borderRadius: "10px",
    display: "flex",
    padding: ".5rem .5rem",
    marginBottom: ".2rem",
    minWidth: "10rem",
}));

const Name = styled('div')(({ theme }) => ({
    fontWeight: "bold"
}));
